const format = (amount: number, currency: string, locale?: string) =>
  new Intl.NumberFormat(locale, { style: "currency", currency }).format(amount);

/**
 * `29,90 €` in `fr`, `₩4,340,000` in `en`. Never throws: rendering an email
 * that throws loses it without a trace. An unknown locale falls back to the
 * runtime's, an unknown currency to `<amount> <currency>`.
 */
export const formatMoney = (
  amount: number,
  currency: string,
  locale?: string | null,
): string => {
  try {
    return format(amount, currency, locale?.replace("_", "-") || undefined);
  } catch {
    try {
      return format(amount, currency);
    } catch {
      return `${amount} ${currency}`;
    }
  }
};
